export default __webpack_public_path__ + "static/media/10w40.e08629d8.png";